export function isoToBrDate(isoString) {
    // Ex: "2022-01-31T09:07:39.0000000+00:00" => "28/01/2022, 09:04:38" => "28/01/2022"
    
    if (!isoString) {
        return ""
    }

    return new Date(isoString).toLocaleString('pt-BR').split(',')[0]
}

function _getObjectItemByPath(obj, path) {
    // Retorna o item no caminho atual ou '' caso o caminho não seja encontrado
    // Caso um dos elementos seja uma lista, ele junta o resultado delas

    const parts = path.split('.')
    let aux = obj

    for (let i = 0; i < parts.length; ++i) {
        const part = parts[i]

        if (typeof aux === 'object') {
            if (aux.hasOwnProperty(part) && Array.isArray(aux[part])) {

                if (aux[part].length > 0) {
                    let items = []
                    for (const index in aux[part]) {
                        const pathRemained = parts.slice(i + 1).join('.')
                        const result = getObjectItemByPath(aux[part][index], pathRemained)
                        if (result !== null)
                            items.push(result)
                    }

                    if (items.length === 0)
                        return ''

                    return items.join(', ')
                }

            } else {
                aux = aux[part]
            }
        } else {
            console.assert(false, 'Não deveria cair aqui')
            return ''
        }
    }
    return aux === void (0) ? '' : aux
}

export function getObjectItemByPath(obj, path) {
    try {
        return _getObjectItemByPath(obj, path) 
    } catch {
        return ''
    }
}